import { render, staticRenderFns } from "./table.vue?vue&type=template&id=317c5fc6&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=317c5fc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c5fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317c5fc6')) {
      api.createRecord('317c5fc6', component.options)
    } else {
      api.reload('317c5fc6', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=317c5fc6&scoped=true", function () {
      api.rerender('317c5fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/McTableComp/table.vue"
export default component.exports